const version = '26.8.28.16dae43';
export default version;



// WEBPACK FOOTER //
// ./src/version.js